import { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { useAuthStore } from "../state/authStore"
import { loginAdmin } from "../api/auth"
import { ApiClientError } from "../api/client"

export default function AdminLoginPage() {
  const navigate = useNavigate()
  const setAdminSession = useAuthStore(s => s.setAdminSession)
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    setError(null)
    if (!username.trim() || !password) {
      setError("Username i password su obavezni.")
      return
    }
    setLoading(true)
    try {
      const result = await loginAdmin(username.trim(), password)
      setAdminSession({
        token: result.sessionToken,
        korisnikId: result.korisnikId,
        ime: result.ime,
        prezime: result.prezime
      })
      navigate("/admin", { replace: true })
    } catch (err) {
      const msg = err instanceof ApiClientError ? (err.detail || err.message) : "Greška."
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-slate-800 mb-2">Admin pristup</h1>
        <p className="text-slate-500 mb-6">SADEO Waiter administracija</p>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Username</label>
            <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-3 focus:border-primary-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => { if (e.key === "Enter") handleSubmit() }} className="w-full border border-slate-300 rounded-lg px-3 py-3 focus:border-primary-500 focus:outline-none" />
          </div>
          {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm">{error}</div>}
          <button onClick={handleSubmit} disabled={loading} className="w-full bg-primary-600 text-white py-3 rounded-lg font-semibold disabled:bg-slate-300">
            {loading ? "Provjeravam..." : "Prijavi se"}
          </button>
        </div>
        <div className="text-center mt-6">
          <Link to="/login" className="text-sm text-slate-500">← Nazad na konobarski login</Link>
        </div>
      </div>
    </div>
  )
}
